// composables/previewConfirm.js
//
// The one confirm before a collector opens a shop's supplier preview — shared
// by the shop's page («اعرض عليه التطبيق») and the shop search («عروض المحلات»)
// so the staff text and the flow are the same wherever he starts.
import { f7 } from 'framework7-vue';
import i18n from '@/i18n';

// F7 dialogs set `text` as HTML, and the shop's name is data from the roster.
const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (c) => ESCAPES[c]);

/**
 * @param {(id: string|number) => unknown} enter useSupplierPreview().enter
 * @param {{id: string|number, name: string}} shop the shop's org id and name
 */
export function confirmAndEnter(enter, { id, name }) {
  if (id == null) return;
  const t = (key, params) => i18n.global.t(key, params);
  f7.dialog
    .create({
      text: t('collector.preview.confirm', { name: escapeHtml(name) }),
      buttons: [
        { text: t('general.cancel') },
        {
          text: t('collector.preview.confirmOpen'),
          strong: true,
          onClick: () => enter(id),
        },
      ],
    })
    .open();
}
